/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {ReactComponent as PaginationStart} from "../assets/img/icons/pagination-start.svg";
import {ReactComponent as PaginationLeft} from "../assets/img/icons/pagination-left.svg";
import {ReactComponent as PaginationRight} from "../assets/img/icons/pagination-right.svg";
import {ReactComponent as PaginationEnd} from "../assets/img/icons/pagination-end.svg";

const ListingBottom = (props) => {

    const goToPage = (e, page) => {
        e.preventDefault();
        const goToStart = (e, page) => {
            if(props.currentPage === 1){ return; }
            //window.scrollTo(0, 0);
            if( props.scrollTop ){ props.scrollTop.current.scrollIntoView(); }
            //props.onChangePage(page);
            props.onChangePage(prevState => ({
                ...prevState,
                page: page,
            }));
        }
        const goToPrev = (e, page) => {
            if(props.currentPage-1 < 1){ return; }
            if( props.scrollTop ){ props.scrollTop.current.scrollIntoView(); }
            props.onChangePage(prevState => ({
                ...prevState,
                page: page,
            }));
        }
        const goToClicked = (e, page) => {
            if(props.currentPage === page){ return; }
            if( props.scrollTop ){ props.scrollTop.current.scrollIntoView(); }
            props.onChangePage(prevState => ({
                ...prevState,
                page: page,
            }));
        }
        const goToNext = (e, page) => {
            if(props.currentPage + 1 > props.totalPages){ return; }
            if( props.scrollTop ){ props.scrollTop.current.scrollIntoView(); }
            props.onChangePage(prevState => ({
                ...prevState,
                page: page,
            }));
        }
        const goToEnd = (e, page) => {
            if(props.currentPage === props.totalPages){ return; }
            if( props.scrollTop ){ props.scrollTop.current.scrollIntoView(); }
            props.onChangePage(prevState => ({
                ...prevState,
                page: page,
            }));
        }
        return{
            goToStart: goToStart,
            goToPrev: goToPrev,
            goToClicked: goToClicked,
            goToNext: goToNext,
            goToEnd: goToEnd
        }

    }

    return (
        <div className='listing-bottom'>
            <ul className={`pagination ${props.green ? "pagination--green" : ""}`}>
                <li><a href='#' className={props.currentPage === 1 ? 'disabled' : ''} onClick={ (e) => {goToPage(e).goToStart(e,1);} }><PaginationStart/></a></li>
                <li><a href='#' className={ props.currentPage-1 < 1 ? 'disabled' : ''} onClick={ (e) => {goToPage(e, props.currentPage - 1).goToPrev(e, props.currentPage - 1);} }><PaginationLeft/></a></li>
                <li><span className='active'>{props.currentPage}</span></li>
                <li><a href='#' className={ props.currentPage+1 > props.totalPages ? 'disabled' : ''} onClick={ (e) => {goToPage(e, props.currentPage + 1).goToNext(e, props.currentPage + 1);} }><PaginationRight/></a></li>
                <li><a href='#' className={props.currentPage === props.totalPages ? 'disabled' : ''} onClick={ (e) => {goToPage(e, props.totalPages).goToEnd(e, props.totalPages);} }><PaginationEnd/></a></li>
            </ul>
        </div>

    );
};

export default ListingBottom;

ListingBottom.defaultProps  = {
    green: false,
    currentPage: 1
}
